import { useAuth } from "@/auth/AuthContext";
import { LoginView } from "@/components/common/LoginView";
import { CompanyPicker } from "@/components/common/CompanyPicker";
import { LoadingView } from "@/components/common/LoadingView";
import { ErrorView } from "@/components/common/ErrorView";
import { MainView } from "./MainView";

export default function App() {
  const { status, error, login, companies, chooseCompany } = useAuth();

  switch (status) {
    case "idle":
      return <LoginView onLogin={login} />;

    case "loading":
      return <LoadingView message="Connecting to Bolsterup..." />;

    case "error":
      return <ErrorView message={error} onRetry={login} />;

    case "select-company":
      return (
        <CompanyPicker companies={companies} onSelect={chooseCompany} />
      );

    case "authenticated":
      return <MainView />;
  }
}
